import React, { useCallback, useRef, useMemo } from 'react'
import { useIntl } from 'react-intl'
import GlobalMobileSearchHeroBar from 'components/SearchV2/Components/Mobile/GlobalMobileSearchHeroBar'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Sheet from 'components/utils/Sheet'
import MerchandiseSearchForm from '../MerchandiseSearch/MerchandiseSearchForm'
import useMerchandiseBrandsList from 'hooks/Merchandise/useMerchandiseBrandsList'
import useMerchandiseBrands from 'hooks/Merchandise/useMerchandiseBrands'

function MerchandiseLandingPageSearchBar() {
  const intl = useIntl()
  const [brandListIds] = useMerchandiseBrandsList({ sortBy: 'top' })
  const [brands] = useMerchandiseBrands(brandListIds)

  const containerRef = useRef<HTMLDivElement>(null)
  const onInputClick = useCallback(() => {
    containerRef.current?.scrollIntoView()
  }, [])

  const searchPlaceholderTextList = useMemo(() => {
    if (brands.length) {
      return brands.map(brand =>
        intl.formatMessage(
          {
            id: 'wslvDTTUMX',
            defaultMessage: 'products in {brandName}',
            description: 'Search placeholder text with brand name',
          },
          { brandName: brand.name },
        ),
      )
    }
    return [
      intl.formatMessage({
        id: 'tNANYjUxDe',
        defaultMessage: 'marketplace',
        description: 'Default search placeholder text for merchandise',
      }),
    ]
  }, [brands, intl])

  return <>
    <CSSBreakpoint max="tablet">
      <GlobalMobileSearchHeroBar
        placeholder={intl.formatMessage({
          id: '7m5wHarQ27',
          defaultMessage: 'Search',
          description: 'Search input placeholder text for merchandise on mobile',
        })}
        placeholderTextList={searchPlaceholderTextList}
      />
    </CSSBreakpoint>
    <CSSBreakpoint min="tablet">
      <Sheet ref={containerRef} padding={16} background="neutral-eight" shadow="flat-small">
        <MerchandiseSearchForm onInputClick={onInputClick} />
      </Sheet>
    </CSSBreakpoint>
  </>
}

export default MerchandiseLandingPageSearchBar
